import { render, staticRenderFns } from "./PmReportManagementForP.vue?vue&type=template&id=ff73f3d4&scoped=true&"
import script from "./PmReportManagementForP.vue?vue&type=script&lang=js&"
export * from "./PmReportManagementForP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff73f3d4",
  null
  
)

export default component.exports